var gsap = require('gsap'),
	common = require('../base/common'),
	emitter = require('../base/emitter');

function Home(){

	var self = this;
	self.onPage = false;

	emitter.on('home:init', function(){

		self.onPage = true;
		self.init();

	})

	emitter.on('page:leave', function(){

		if(self.onPage){

			self.onPage = false;
			common.$window.off('scroll.home');
			common.$document.off('touchmove.home');
			common.$window.off('resize.home');

		}

	})

}

Home.prototype.checkScroll = function(){

	var self = this;
	if(!self.onPage) return;

	if($('body').hasClass('show-menu') || $('body').hasClass('show-contacts')) return;

	if(self.scrollTop + common.screen.height > self.settings.boxHeight){

		if(!self.$bg.hasClass('outside'))
			self.$bg.addClass('outside')

		var offset = self.scrollTop + common.screen.height - self.settings.boxHeight;
		TweenLite.set(self.$bg,{y: -offset})

	}else{

		if(self.$bg.hasClass('outside')){
			self.$bg.removeClass('outside')
			TweenLite.set(self.$bg,{ y: 0 })
		}

	}

	if(self.scrollTop >= self.$titleParent.offset().top){
		if(!self.$titleParent.hasClass('on-view')){
			self.$titleParent.addClass('on-view');
		}
	}else{
		if(self.$titleParent.hasClass('on-view')){
			self.$titleParent.removeClass('on-view');
		}
	}

	// if(self.scrollTop + (common.screen.height * 0.5 + self.settings.titleHeight * 0.8) >= self.settings.textOffset){
	if(self.scrollTop + (common.screen.height * 0.5 + self.settings.titleHeight * 0.8) >= self.settings.textOffset){
		var offset = self.scrollTop + (common.screen.height * 0.5 + self.settings.titleHeight * 0.8) - self.settings.textOffset;
		TweenLite.set(self.$title, {y: -(offset + self.settings.titleHeight) })
	}else{
		TweenLite.set(self.$title, {y: -(self.settings.titleHeight) });
	}

	if(self.scrollTop >= 0 && self.scrollTop <= common.screen.height * 1){

		// animate bg
		self.settings.perc = self.scrollTop / (common.screen.height * 1);

	}else{

		self.settings.perc = 1;

	}

	if(self.settings.perc <= 1){


		TweenLite.to(self.$bg.find('.home-bg--mask1'),0.3,{ width: (50 * self.settings.perc) + '%' })
		TweenLite.to(self.$bg.find('.home-bg--mask2'),0.3,{ width: ((common.screen.width > 768 ? 16 : 50) * self.settings.perc) + '%' })
		TweenLite.to(self.$bg.find('.home-bg--mask3'),0.3,{ height: (50 * self.settings.perc) + 'px' })

	}else{

		TweenLite.set(self.$bg.find('.home-bg--mask1'),{ width: '50%' })
		TweenLite.set(self.$bg.find('.home-bg--mask2'),{ width: (16 * self.settings.perc) + '%' })
		TweenLite.set(self.$bg.find('.home-bg--mask3'),{ height: (50 * self.settings.perc) + 'px' })

		// do something

	}

	if(self.scrollTop > 0)
		common.$body.addClass('show-page-status');
	else
		common.$body.removeClass('show-page-status');

	self.settings.globalPerc = self.scrollTop / (common.$document.height() - common.$window.height());
	TweenLite.to(self.$pageStatus, 0.3, {height: (100 * self.settings.globalPerc) + '%'});

}

Home.prototype.resize = function(){

	var self = this;
	self.settings = {

		boxHeight: $('#block-home').height(),
		textOffset: self.$text.offset().top,
		titleHeight: self.$title.height() * 0.5,
		perc: 0

	}

	var pageStatusHeight = (common.$window.height() - $('footer').height() * 2) * 0.8;
	$('.page-status').height(pageStatusHeight + 'px' )

}

Home.prototype.init = function(){

	var self = this;

	self.$block = $('#block-home');
	self.$bg = self.$block.find('.home-bg');
	self.$title = self.$block.find('.home-title');
	self.$titleParent = self.$title.closest('.part');
	self.$text = self.$block.find('.home-text');
	self.$textParent = self.$text.closest('.part');
	self.$pageStatus = $('.page-status div');

	$(document).on('touchmove.home', function(e){
		self.scrollTop = common.$window.scrollTop();
		self.checkScroll();
	})

	common.$window.on('scroll.home', function(e){
		self.scrollTop = common.$window.scrollTop();
		self.checkScroll();
	})

	common.$window.on('resize.home', function(){
		self.resize();
	})

	self.resize();

}


module.exports = Home;


/** WEBPACK FOOTER **
 ** ./layouts/home.js
 **/